export const startFetchResource = 'startFetchResource';
export const doneFetchResource = 'doneFetchResource';
export const failFetchResource = 'failFetchResource';
export const startFetch = 'startFetch';
export const doneFetch = 'doneFetch';
export const failFetch = 'failFetch';
